import React from 'react';
import Button from '../button/Button';
import Button02 from '../button/Button02';
import { useTranslation } from 'react-i18next';
// import img from '../../assets/images/slider/bg-slider.jpg'

function Banner02(props) {
    const { t } = useTranslation();



    return (
        <section className="tf-slider home2" style={{backgroundImage: `url(${props.img})`}}>
            <div className="container-fluid">

                <div className="row">
                    <div className="col-md-12">

                        <div className="tf-slider-item style-2">
                            <div className="content-inner wow fadeInUp" data-wow-delay="0.4s">
                                <h1 className="heading">{t('cheapEAFC26Coins')}</h1>
                                <p className="sub-heading wow fadeInUp" style={{marginLeft:"15px",marginRight:"15px"}} data-wow-delay="0.6s">
                                    {t('lowestPricesEASportsFC26')}
                                </p>
                                <div className="btn-slider wow fadeInUp" data-wow-delay="0.8s">
                                    {/* <Button title={t('sell_your_coins')} path="/sells" /> */}
                                    <Button02 title={t('buy_fc_coins')} path="/collection" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

    );
}

export default Banner02;